/**
 * Returns `url` if it is an absolute https URL, and throws otherwise.
 *
 * For any URL the API hands back for the browser to open or navigate to: an OAuth authorization URL, a
 * signed report link. They are built server-side with fixed https hosts, but nothing here checked that,
 * and a `javascript:` URL given to `window.open` or `location.href` runs in the dashboard's own origin.
 */
export function httpsUrlOrThrow(url: string): string {
    let parsed: URL
    try {
        parsed = new URL(url)
    } catch {
        throw new Error('Refused to open a malformed URL')
    }
    if (parsed.protocol !== 'https:') {
        throw new Error(`Refused to open a ${parsed.protocol} URL`)
    }
    return parsed.href
}
